import { cva, VariantProps } from 'class-variance-authority';

export const toastVariants = cva(['flex flex-row gap-x-12 border p-16'], {
  variants: {
    size: {
      default: 'rounded-12 md:rounded-18',
      small: 'rounded-12',
    },
    variant: {
      default: 'bg-grayscale50 border-grayscale300 text-grayscale600',
      success: 'bg-success50 border-success300 text-grayscale600',
      error: 'bg-error50 border-error300 text-grayscale600',
      warning: 'bg-warning50 border-warning300 text-grayscale600',
      info: 'bg-info50 border-info300 text-grayscale600',
    },
  },
  defaultVariants: {
    size: 'default',
    variant: 'info',
  },
});

export const toastIconVariants = cva([], {
  variants: {
    variant: {
      default: 'fill-grayscale300',
      success: 'fill-success300',
      error: 'fill-error300',
      warning: 'fill-warning300',
      info: 'fill-info300',
    },
    defaultVariants: {
      variant: 'info',
    },
  },
});

export type ToastVariants = VariantProps<typeof toastVariants>;
